export default __webpack_public_path__ + "static/media/icon_200.3e438379.png";